import { atom } from "@mongez/react-atom";
import { User } from "../types";

export const userAtom: any = atom<User>({
  key: "user",
  default: {},
  beforeUpdate: (user) => ({
    ...user,
    fullName: `${user?.firstName} ${user?.lastName}`,
    headerName: user?.lastName?.charAt(0).toLocaleUpperCase() || "~",
  }),
});
